import React, { Component } from "react";
import MalidCard from "./MalidCard";

class ONPView extends Component {
  state = {
    onpData: [],
    loading: false,
    error: null,
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  componentDidUpdate(prevProps) {
    var prevIds = this.extractIds(prevProps.data);
    var newIds = this.extractIds(this.props.data);

    if (JSON.stringify(prevIds) !== JSON.stringify(newIds)) {
      this.loadData(this.props);
    }
  }

  extractIds = (data) => {
    if (!data) return [];

    var arr = Array.isArray(data) ? data : [data];
    var ids = [];

    for (var i = 0; i < arr.length; i++) {
      if (arr[i] && arr[i].id) {
        ids.push(arr[i].id);
      }
    }

    return ids;
  };

  loadData = (props) => {
    var ids = this.extractIds(props.data);

    if (!ids.length) {
      this.setState({ onpData: [], loading: false, error: null });
      return;
    }

    this.setState({ loading: true, error: null, onpData: [] });

    var requests = ids.map((id) => {
      return fetch("https://onp.ku.dk/json/onp/" + id).then((res) => res.json());
    });

    Promise.all(requests)
      .then((results) => {
        this.setState({ onpData: results, loading: false });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ error: err, loading: false });
      });
  };

  cleanONPText = (str) => {
    return str;
    if (!str) return "";

    return str
      .replace(/<\\u[0-9a-fA-F]{4}.*?>/g, "")
      .replace(/●+/g, "")
      .replace(/\u2e22/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/\s+/g, " ")
      .replace(/<(?!\/?u\b)[^>]+>/g, "")
      .replace(/^[IVX]+\.\s*/i, "")
      .replace(/^\d+\)\s*/, "")
      .trim();
  };

  getTotalExampleCount = (item) => {
    if (!item || !Array.isArray(item.senses)) {
      return 0;
    }

    return item.senses.reduce((total, sense) => {
      var examples = sense["ontolex:example"];

      if (!Array.isArray(examples)) {
        return total;
      }

      return total + examples.length;
    }, 0);
  };

  render() {
    var data = this.state.onpData;

    if (!data || !Array.isArray(data)) {
      data = [];
    }

    return (
      <MalidCard
        title={window.l("onp_title")}
        count={this.props.count || data.length}
        visible={data.length > 0}
        frontPage={this.props.frontPage}
        database="onp"
        aboutText={window.l("onp_about")}
        className="truncated"
      >
        {this.state.loading && <div>Sæki gögn …</div>}
        {this.state.error && <div>Gögn vantar</div>}
        {!this.state.loading && data.length === 0 && <div>Gögn vantar</div>}

        <div className="onp-senses-container">
          {data.map((item, index) => {
            var writtenRep = item && item.canonicalForm && item.canonicalForm.writtenRep ? item.canonicalForm.writtenRep : "—";

            var oldestCitation = item && item["onp-oldest-citation"] ? item["onp-oldest-citation"] : {};

            return (
              <div className="onp-sense-container" key={"data-item-" + index}>
                <strong className="onp-lemma">{writtenRep}</strong>
                <div className="onp-example-container">
                  <u className="onp-example-title">Elsta dæmi:</u>
                  <p className="onp-example-text" dangerouslySetInnerHTML={{ __html: this.cleanONPText(oldestCitation["citation-text"]) }}></p>
                  <a href={oldestCitation["canonical-uri"]} target="_blank" className="onp-citation-text">
                    ({oldestCitation["work-title"]}, {oldestCitation["msdate"]})
                  </a>
                </div>

                {item && item["onp-canonicalurl"] && (
                  <div>
                    <a className="text-light" href={item["onp-canonicalurl"]} target="_blank" rel="noopener noreferrer">
                      {window.l("open_dict_generic")} ({this.getTotalExampleCount(item)} dæmi)
                    </a>
                  </div>
                )}
                {index < data.length - 1 && <hr className="onp-item-divider" />}
              </div>
            );
          })}
        </div>
      </MalidCard>
    );
  }
}

export default ONPView;


// WEBPACK FOOTER //
// ./src/components/ONPView.js